import axios from 'axios';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { identity, ifElse } from 'ramda';

var isFormData = function isFormData(data) {
  return data && data.toString && data.toString() === '[object FormData]';
};

export var toDefaultRequestTransforms = function toDefaultRequestTransforms() {
  return [].concat(decamelizeIf, axios.defaults.transformRequest || []);
};
export var decamelizeKeysWithNumbers = function decamelizeKeysWithNumbers(str) {
  return decamelizeKeys(str, {
    split: /(?=[A-Z0-9])/
  });
};
export var decamelizeIf = ifElse(isFormData, identity, decamelizeKeysWithNumbers);
export var toDefaultResponseTransforms = function toDefaultResponseTransforms() {
  return [].concat(axios.defaults.transformResponse || [], camelizeKeys);
};